
import { t } from '@/plugins/i18n'
// 1-待入库 2-入库中 4-已完成 5-已取消
export enum StatuEnum {
  PENDING_STORAGE = 1, // 待入库
  IN_STORAGE = 2, // 入库中
  COMPLETED = 4, // 已完成
  CANCELED = 5 // 已取消
}

export const statusList = [
  {
    value: StatuEnum.PENDING_STORAGE,
    label: t('待入库')
  },
  {
    value: StatuEnum.IN_STORAGE,
    label: t('入库中')
  },
  {
    value: StatuEnum.COMPLETED,
    label: t('已完成')
  },
  {
    value: StatuEnum.CANCELED,
    label: t('已取消')
  }
]

export const entryListColumns = [
  {
    label: '入荷注文番号',
    prop: 'inboundCode',
    slotName: 'inboundCodeSlot'
  },
  {
    label: '発注コード',
    prop: 'customerInboundCode',
    slotName: 'customerInboundCodeSlot'
  },
  {
    label: '入荷予定类型',
    prop: 'inboundType',
    slotName: 'inboundTypeSlot'
  },
  {
    label: '発注日',
    prop: 'orderTime',
    slotName: 'orderTimeSlot'
  },
  {
    label: '仕入先',
    prop: 'supplierName',
    width: 100
  },
  {
    label: '納品先',
    prop: 'receiverWarehouse',
    slotName: 'receiverWarehouseSlot',
    width: 220
  },
  {
    label: t('操作'),
    prop: 'action',
    align: 'center',
    width: 220,
    slotName: 'actionSlot'
  }
]

export const statusMap = {
  [StatuEnum.PENDING_STORAGE]: t('待入库'),
  [StatuEnum.IN_STORAGE]: t('入库中'),
  [StatuEnum.COMPLETED]: t('已完成'),
  [StatuEnum.CANCELED]: t('已取消')
}

export const statusMapType = {
  [StatuEnum.PENDING_STORAGE]: 'warning',
  [StatuEnum.IN_STORAGE]: 'success',
  [StatuEnum.COMPLETED]: 'info',
  [StatuEnum.CANCELED]: 'info'
}
